'use client';

/**
 * Registro do Service Worker, compartilhado por push do chat e voz.
 *
 * Antes isto vivia INLINE dentro do `subscribe()` do `use-push-subscription`
 * (`navigator.serviceWorker.register('/sw.js')`), e o `subscribe()` so roda
 * quando o agente ativa o push do chat. Consequencia: quem nunca ativou o push
 * NAO TEM Service Worker — e a notificacao nativa de chamada (#435), que
 * depende de `registration.showNotification`, nasceria morta pra boa parte dos
 * atendentes. Extraido pra que o fluxo de voz registre por conta propria.
 *
 * `register()` e idempotente: chamada repetida com o mesmo script e escopo
 * devolve a registration existente, sem reinstalar nada.
 */
export async function ensureServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined') return null;
  if (!('serviceWorker' in navigator)) return null;

  try {
    return await navigator.serviceWorker.register('/sw.js');
  } catch (err) {
    // Falha de registro nao pode quebrar a tela: quem chamou decide o fallback.
    console.warn('[sw] registro falhou', err);
    return null;
  }
}
